import { Box, Button, Flex, Grid, rem, TextInput } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconCalendar, IconFileExport, IconSearch } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateTime } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { DeliveryTransaction } from "../../../model/DeliveryMoneyReport";
import { MessageResponse } from "../../../model/MessageResponse";
//Báo cáo các đơn hàng trùng mã KH trong cùng một ngày

const ReportOnOrders = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DeliveryTransaction[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [dataTblDeliveryStatusSelect, setDataTblDeliveryStatusSelect] =
    useState<ComboboxItem[]>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  // //Mã nhân viên
  // const [dataEmployee, setDataEmployee] = useState<SelectListItemModel[]>([]);

  // //dataExportExcel
  // const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 2.5 };
  const innitStateSearch = React.useMemo(() => {
    const now = dayjs();
    const startOfMonth = now.startOf("month").format("YYYY-MM-DDTHH:mm:ss");
    const endOfMonth = now.endOf("month").format("YYYY-MM-DDTHH:mm:ss");

    return {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      FromDate:
        _searchJson && checkedPinSearch ? _searchJson?.FromDate : startOfMonth,
      ToDate:
        _searchJson && checkedPinSearch ? _searchJson?.ToDate : endOfMonth,
    };
  }, []);

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      // Tạo URLSearchParams để quản lý các tham số
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch, ToDate, FromDate } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);

      // Always include date parameters - they will have default values from the form initialization
      params.append("FromDate", FromDate || "");
      params.append("ToDate", ToDate || "");

      const url = `/api/v1/TblDelivery/get-list-check-duplicate-customers-in-one-day?${params.toString()}`;

      const response = await repositoryDelivery.get<MessageResponse<any>>(
        `${url}`
      );
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSeachInput.getValues())
      );
    }
  };
  const columns = React.useMemo<MRT_ColumnDef<DeliveryTransaction>[]>(
    () => [
      {
        accessorKey: "customerCode",
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "customerName",
        header: "tên khách hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "companyName",
        header: "Tên doanh nghiệp",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      {
        accessorKey: "masterOrgs",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "orderDate",
        header: "Ngày bắn đơn",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTime(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "orderCount",
        header: "Số đơn trong ngày",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "assignmentDates",
        header: "Thời gian phân công giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 300,
      },
      {
        accessorKey: "assignmentCount",
        header: "Tổng số vận đơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "assignmentCodes",
        header: "Tổng hợp mã vận đơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 200,
      },
      {
        accessorKey: "orderCodes",
        header: "Tổng hợp mã đơn hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
      {
        accessorKey: "orderDates",
        header: "Tổng hợp thời gian bắn đơn giao",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,

        size: 270,
      },
      {
        accessorKey: "toAddresses",
        header: "Tổng hợp địa chỉ giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 250,
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["transactionNumber", "sourceCode"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  const handleExport = async () => {
    open(); // Hiển thị loading
    try {
      // Tạo URLSearchParams để quản lý các tham số
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch, ToDate, FromDate } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      if (FromDate) params.append("FromDate", FromDate);
      if (ToDate) params.append("ToDate", ToDate);
      const baseUrl = `/api/v1/TblDelivery/export-duplicate-customers-in-one-day?${params.toString()}`;
      const _url = BASE_API_DELIVERY + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename =
        "bao_cao_cac_don_hang_trung_ma_KH_trong_cung_mot_ngay.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };
  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => handleExport()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              maxDate={new Date()}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
              key={formSeachInput.key("ToDate")}
              {...formSeachInput.getInputProps("ToDate")}
              value={
                formSeachInput.getValues().ToDate
                  ? dayjs(formSeachInput.getValues().ToDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              maxDate={new Date()}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReportOnOrders;
